import React from 'react';
import { useForm, useFormState } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'hooks/useSelector';
import { getSignInLoading } from 'modules/auth/selectors';

import { Button } from 'ui/base';

const LoginFooter = () => {
  const { submit } = useForm();
  const { invalid, pristine } = useFormState();
  const isSigningIn = useSelector(getSignInLoading);
  const disabled = invalid || pristine;

  return (
    <div className="text-right">
      <Button onClick={submit} type="primary" loading={isSigningIn} disabled={disabled} data-cy="login_button">
        <FormattedMessage id="ok" defaultMessage="Ok" />
      </Button>
    </div>
  );
};

export default LoginFooter;
